import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {StatesService} from '../../../../../../../shared/services/state/states.service';
import {UserService} from '../../../../../../../shared/services/user/user.service';
import {DeviceService} from '../../../../../../../shared/services/device/device.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {map} from 'rxjs/internal/operators';
import {ReferentialService} from '../../../../../../../shared/services/referential/referential.service';
import {ProjectDeviceLocation} from '../../../../../../../shared/classes/project-device-location/project-device-location';
import {ProjectService} from '../../../../../../../shared/services/project/project.service';

@Component({
  selector: 'app-project-device-location-add',
  templateUrl: './project-device-location-add.component.html',
  styleUrls: ['./project-device-location-add.component.css']
})
export class ProjectDeviceLocationAddComponent implements OnInit {


  public displayedColumns: string[] = ['uid', 'action'];
  public devices: MatTableDataSource<any>;
  public faPlus = faPlus;
  public deviceTypeSelected: number = 0;

  public showSpinner: boolean = false;
  public projectDeviceLocation: any;
  public projectId: number;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(public activeModal: NgbActiveModal,
              private userService: UserService,
              private deviceService: DeviceService,
              private referentialService: ReferentialService,
              private statesService: StatesService,
              private toastr: ToastrService,
              private translate: TranslateService,
              private projectService: ProjectService) {
  }

  ngOnInit() {

  }

  getDeviceAvailableByType(type: number) {
    this.showSpinner = true;
    this.deviceService.getDevicesAvailableByDevicesType(type, this.projectId)
      .subscribe(
        (data: any) => {
          this.devices = new MatTableDataSource(data ? data : []);
          this.devices.filter = null;
          this.devices.sort = this.sort;
          this.devices.paginator = this.paginator;
          this.showSpinner = false;
        }
        ,
        error2 => {
          this.showSpinner = false;
        }
      );
  }

  filterListByDeviceType(type: number) {
    if (this.deviceTypeSelected !== type) {
      this.deviceTypeSelected = type;
    } else {
      this.deviceTypeSelected = 0;
    }
    if (this.deviceTypeSelected !== 0) {
      this.getDeviceAvailableByType(this.deviceTypeSelected);
    } else {
      this.devices.data = [];
    }

  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.devices.filter = filterValue;
  }

  patchProjectDeviceLocation(deviceId) {
    this.showSpinner = true;
    let projectDeviceLocation = new ProjectDeviceLocation();
    projectDeviceLocation.device = deviceId;
    this.projectService.patchProjectDeviceLocation(this.projectDeviceLocation.id, projectDeviceLocation)
      .subscribe(
        (data: any) => {
          this.showSpinner = false;
          this.getDeviceAvailableByType(this.deviceTypeSelected);
          this.toastr.success('Device added to location : ' + this.projectDeviceLocation.name, this.translate.instant('SUCCESS'));
          this.statesService.reloadProjectLocation.next();

        }
        ,
        error2 => {
          this.showSpinner = false;
        }
      )

  }

}
